import { useEffect, useState } from "react";
import api from "../api/api";

function Transactions() {
  const [books, setBooks] = useState([]);
  const [members, setMembers] = useState([]);
  const [transactions, setTransactions] = useState([]);
  const [form, setForm] = useState({ book_id: "", member_id: "" });

  useEffect(() => {
    api.get("/books/").then(res => setBooks(res.data));
    api.get("/members/").then(res => setMembers(res.data));
    api.get("/transactions").then(res => setTransactions(res.data)).catch(() => {});
  }, []);

  const issueBook = async (e) => {
    e.preventDefault();
    await api.post("/transactions/issue", form);
    alert("Book Issued!");
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Issue Book</h2>

      <form onSubmit={issueBook}>
        <select onChange={e => setForm({ ...form, book_id: e.target.value })} required>
          <option value="">Select Book</option>
          {books.map(b => <option key={b._id} value={b._id}>{b.title}</option>)}
        </select>

        <select onChange={e => setForm({ ...form, member_id: e.target.value })} required>
          <option value="">Select Member</option>
          {members.map(m => <option key={m._id} value={m._id}>{m.name}</option>)}
        </select>

        <button type="submit">Issue</button>
      </form>
    </div>
  );
}

export default Transactions;